/**
 * @generated SignedSource<<c7cb3c6744065d4a76578914f6905c50>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type NftPublicProfileAddressRespLayout_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"NftProfileCollection_viewer" | "useHasMinterRole_viewer">;
  readonly " $fragmentType": "NftPublicProfileAddressRespLayout_viewer";
};
export type NftPublicProfileAddressRespLayout_viewer$key = {
  readonly " $data"?: NftPublicProfileAddressRespLayout_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"NftPublicProfileAddressRespLayout_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "collectionCursor"
    },
    {
      "kind": "RootArgument",
      "name": "collectionFirst"
    },
    {
      "kind": "RootArgument",
      "name": "creationsCursor"
    },
    {
      "kind": "RootArgument",
      "name": "creationsFirst"
    },
    {
      "kind": "RootArgument",
      "name": "draftsCursor"
    },
    {
      "kind": "RootArgument",
      "name": "draftsFirst"
    },
    {
      "kind": "RootArgument",
      "name": "fetchDrafts"
    },
    {
      "kind": "RootArgument",
      "name": "fetchUser"
    },
    {
      "kind": "RootArgument",
      "name": "hasTokenContractId"
    },
    {
      "kind": "RootArgument",
      "name": "liveAuctionsCursor"
    },
    {
      "kind": "RootArgument",
      "name": "liveAuctionsFirst"
    },
    {
      "kind": "RootArgument",
      "name": "liveBidsCursor"
    },
    {
      "kind": "RootArgument",
      "name": "liveBidsFirst"
    },
    {
      "kind": "RootArgument",
      "name": "lostBidsCursor"
    },
    {
      "kind": "RootArgument",
      "name": "lostBidsFirst"
    },
    {
      "kind": "RootArgument",
      "name": "tokenContractId"
    },
    {
      "kind": "RootArgument",
      "name": "userId"
    },
    {
      "kind": "RootArgument",
      "name": "username"
    },
    {
      "kind": "RootArgument",
      "name": "walletAddress"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "refetch": {
      "connection": null,
      "fragmentPathInResult": [
        "viewer"
      ],
      "operation": require('./NftPublicProfileAddressRespLayoutRefetchQuery.graphql')
    }
  },
  "name": "NftPublicProfileAddressRespLayout_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "NftProfileCollection_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useHasMinterRole_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "1d8812e1d4280cd6caeff0ff2f37115c";

export default node;
